// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".is-divider[data-v-0826f898] {\n  margin: 1.2em 0;\n}\n.subtext[data-v-0826f898] {\n  font-size: 10px;\n}", ""]);
// Exports
module.exports = exports;
